import React, {FC, useEffect, useState} from 'react'
import classes from './BulkRunTableHeader.module.scss'
import {Form} from 'react-bootstrap'
import {useAppDispatch, useAppSelector} from '../../../../store/store'
import {setSortingDirection} from '../../../../store/bulk-run/bulkRunSlice'
import {useTranslation} from 'react-i18next'
import {getWorkflowInputValueKeyByLangKey} from '../combined-form/utils'

interface BulkRunTableHeaderProps {
  templateItem: any
}

const BulkRunTableHeader: FC<BulkRunTableHeaderProps> = ({templateItem}) => {
  const [isChecked, setIsChecked] = useState(false)

  const dispatch = useAppDispatch()
  const {t} = useTranslation()
  const isAllRowsSelected = useAppSelector((state) => state.bulkRun.selectAllCheckbox)
  const sortingDirection = useAppSelector((state) => state.bulkRun.sortingDirection)

  const handleSortChange = () => {
    // Toggle the sorting direction: if it's 'ASC', change to 'DESC', and vice versa
    const newSortingDirection =
      sortingDirection === 'ASC' ? 'DESC' : sortingDirection === 'DESC' ? 'ASC' : 'ASC'
    dispatch(setSortingDirection(newSortingDirection))
  }

  useEffect(() => {
    setIsChecked(isAllRowsSelected)

    const checkboxes = document.querySelectorAll('td input[type="checkbox"]')
    checkboxes.forEach((checkbox: any) => {
      checkbox.checked = isAllRowsSelected
    })
  }, [isAllRowsSelected])

  const handleCheckboxChange = (e: any) => {
    const isCheckedNow = e.target.checked
    setIsChecked(isCheckedNow)

    const checkboxes = document.querySelectorAll('td input[type="checkbox"]')

    checkboxes.forEach((checkbox: any) => {
      checkbox.checked = isCheckedNow
    })
  }

  const {requiredQuestions, additionalQuestions, optionalSelect, imgGenerate, formType} =
    templateItem

  const requiredQuestionsHeaders = requiredQuestions.map((item: any, index: number) => (
    <th key={index} className={classes.thead__questionHeader}>
      {t(
        getWorkflowInputValueKeyByLangKey(
          templateItem.header,
          templateItem.lang_key,
          item.lang_key,
          'title'
        )
      )}{' '}
      <span className={classes.required}>*</span>
    </th>
  ))

  const additionalQuestionsHeaders = additionalQuestions.map((item: any, index: number) => (
    <th key={index} className={classes.thead__questionHeader}>
      {t(
        getWorkflowInputValueKeyByLangKey(
          templateItem.header,
          templateItem.lang_key,
          item.lang_key,
          'title'
        )
      )}
    </th>
  ))

  const optionalSelectHeaders = optionalSelect.map((item: any, index: number) => {
    const title = item.title

    console.log('title', title)

    if (title === 'Tone') {
      return (
        <th key={index} className={classes.thead__selectHeader} style={{width: '11%'}}>
          {t('workflows.common.tone')}
        </th>
      )
    } else if (title === 'Length') {
      return (
        <th key={index} className={classes.thead__selectHeader} style={{width: '11%'}}>
          {t('workflows.common.length')}
        </th>
      )
    } else {
      return (
        <th key={index} className={classes.thead__selectHeader} style={{width: '11%'}}>
          {t(
            getWorkflowInputValueKeyByLangKey(
              templateItem.header,
              templateItem.lang_key,
              item.lang_key,
              'title'
            )
          )}
        </th>
      )
    }
  })

  const isScreeningWorkflow =
    window.location.href.includes('description-comparer-custom') ||
    window.location.href.includes('screen-custom')

  return (
    <thead className={classes.thead}>
      <tr>
        <th className={'align-middle'} style={{width: '20px'}} id='table-checkbox-header'>
          <Form.Check>
            <Form.Check.Input
              isValid
              type={'checkbox'}
              onChange={handleCheckboxChange}
              checked={isChecked}
            />
          </Form.Check>
        </th>

        <th style={{width: '5%'}}>{t(`workflows.common.run`)}</th>
        {requiredQuestionsHeaders}
        {optionalSelectHeaders}
        <th className={classes.thead__selectHeader} style={{width: '10%'}}>
          {t(`workflows.common.output_language`)}
        </th>
        {formType === 'social' && (
          <>
            <th className={classes.thead__selectHeader}>
              {' '}
              {t(`workflows.common.number_of_variations`)}
            </th>
            <th className={classes.thead__selectHeader}>
              {t(`workflows.common.media_selector`)} <span className={classes.required}>*</span>
            </th>
          </>
        )}
        {additionalQuestionsHeaders}

        {isScreeningWorkflow && (
          <th style={{width: '10%'}} onClick={handleSortChange}>
            {t(`workflows.common.rating`)} (1-10)
          </th>
        )}
        <th style={{width: '20%'}}>{t(`workflows.common.result`)}</th>
        <th style={{width: '8%'}}>{t(`workflows.common.action`)}</th>
      </tr>
    </thead>
  )
}

export default BulkRunTableHeader
